import React from 'react';
import Masonry from 'react-masonry-css';
import ProductBlock from 'shared/components/likiee/ProductBlock';
import { FolderIconFilled, TrashIconFilled } from 'shared/components/Icons';

const RecomendedItems = ({ data, title, onProductRemove, onClickProductProject }) => {
  return (
    <div className='mt-15'>
      {title && <h1>{title}</h1>}
      <Masonry
        breakpointCols={{
          default: 4,
          1100: 3,
          500: 2,
        }}
        className='recomended-items-grid pl-6 pl-md-0'
        columnClassName='recomended-items-grid-column'
      >
        {data.map((item, i) => {
          const actionButtons = [
            { logo: <TrashIconFilled />, onClick: onProductRemove.bind(null, item) },
            { logo: <FolderIconFilled />, onClick: onClickProductProject.bind(null, item) },
          ];
          return (
            <ProductBlock
              product={item}
              key={i}
              actionButtons={actionButtons}
              showDate={true}
              notAvailable={item.availability === 'OutOfStock'}
            />
          );
        })}
      </Masonry>
    </div>
  );
};

export default RecomendedItems;
